/**
 * Authentication Helper
 * Utilities for handling authentication tokens
 */

/**
 * Get access token from localStorage/sessionStorage
 * @returns {string|null} Access token if found, null otherwise
 */
export const getAccessToken = () => {
    const possibleKeys = [
        "token",
        "accessToken",
        "access_token",
        "authToken",
        "jwt",
    ];

    for (const key of possibleKeys) {
        const token =
            localStorage.getItem(key) ||
            sessionStorage.getItem(key);
        if (token) {
            return token;
        }
    }

    console.warn("⚠️ No access token found");
    return null;
};

/**
 * Create headers with optional authentication
 * @param {boolean} includeAuth - Whether to include auth header
 * @returns {Object} Headers object
 */
export const createHeaders = (includeAuth = true) => {
    const headers = {
        "Content-Type": "application/json",
    };

    if (includeAuth) {
        const token = getAccessToken();
        if (token) {
            headers["Authorization"] = `Bearer ${token}`;
        }
    }

    return headers;
};
